import c3 from 'c3/c3';
import UsageChartHelper from './usage.chart.helper';
export default function ($document, $element, $timeout) {
  var _this = this;
  this.$onChanges = function (change) {
    _this._unused = _this.unlimited ? 0 : Math.max(_this.unused, 0);
    if (_this.initial && _this.used === '0') {
      _this._used = Math.max(_this.initial - _this._unused, 0);
    } else {
      _this._used = _this.unlimited ? 100 : Math.max(_this.used, 0);
    }
    _this._unlimited = _this.unlimited || null;
    _this.size = _this.size || 'small';
    if (!_this._unused && !_this._used) {
      _this._unused = 1;
    }
    _this.hexValue = UsageChartHelper.getHexValueByUsage(_this._used, _this._unused, _this._unlimited);
    if (_this.chart && (change.used || change.unused)) {
      _this.loadNewData();
    } else {
      _this.generatePromise = $timeout(function () {
        _this.generateChart();
      });
    }
  };
  this.$onDestroy = function () {
    _this.generatePromise && $timeout.cancel(_this.generatePromise);
  };
  this.getSharedProperties = function () {
    return {
      columns: [['used', _this._used], ['reserved', Math.max(_this.reserved, 0)], ['unused', _this._unused]],
      colors: {
        reserved: UsageChartHelper.C3_HEX_VALUES.RESERVED,
        unused: UsageChartHelper.C3_HEX_VALUES.UNUSED,
        used: _this.hexValue
      },
      order: null
    };
  };
  this.loadNewData = function () {
    _this.chart.load(Object.assign({
      unload: ['used', 'unused', 'reserved']
    }, _this.getSharedProperties()));
  };
  this.generateChart = function () {
    _this.chart = c3.generate({
      bindto: $element[0],
      interaction: {
        enabled: false
      },
      data: Object.assign({
        labels: false,
        type: 'donut'
      }, _this.getSharedProperties()),
      donut: {
        label: {
          show: false
        },
        width: _this.size === 'large' ? 20 : _this.size === 'medium' ? 10 : 7
      },
      tooltip: {
        show: false
      },
      legend: {
        show: false
      },
      size: {
        height: _this.size === 'large' ? 240 : _this.size === 'medium' ? 120 : undefined
      },
      transition: {
        duration: 200
      }
    });
  };
  $document.ready(function () {
    $timeout(function () {
      _this.chart && _this.chart.resize();
    }, 2000);
  });
}